(function () {
  'use strict';

  if (window.mdvCollectionRailLifecycle) return;
  window.mdvCollectionRailLifecycle = true;
  var cleanup = new WeakMap();

  function initialiseRail(shell) {
    if (shell.dataset.mdvRailInitialised === 'true') return;

    var rail = shell.querySelector('[data-mdv-collection-rail-list]');
    var previous = shell.querySelector('[data-mdv-rail-previous]');
    var next = shell.querySelector('[data-mdv-rail-next]');
    var items = rail ? rail.querySelectorAll('.mdv-collection-rail__item') : [];

    if (!rail || !previous || !next || items.length === 0) return;
    shell.dataset.mdvRailInitialised = 'true';

    var frame = null;
    var disposed = false;

    function update() {
      frame = null;
      if (disposed) return;

      var bounds = rail.getBoundingClientRect();
      var minLeft = Infinity;
      var maxRight = -Infinity;
      var isRtl = window.getComputedStyle(rail).direction === 'rtl';

      items.forEach(function (item) {
        var bounds = item.getBoundingClientRect();
        minLeft = Math.min(minLeft, bounds.left);
        maxRight = Math.max(maxRight, bounds.right);
      });

      var hasPrevious = isRtl ? maxRight > bounds.right + 2 : minLeft < bounds.left - 2;
      var hasNext = isRtl ? minLeft < bounds.left - 2 : maxRight > bounds.right + 2;

      previous.hidden = !hasPrevious;
      next.hidden = !hasNext;
    }

    function requestUpdate() {
      if (disposed || frame !== null) return;
      frame = window.requestAnimationFrame(update);
    }

    function move(direction) {
      var isRtl = window.getComputedStyle(rail).direction === 'rtl';
      var inlineDirection = isRtl ? -direction : direction;
      rail.scrollBy({
        left: inlineDirection * rail.clientWidth * 0.7,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    function movePrevious() { move(-1); }
    function moveNext() { move(1); }

    previous.addEventListener('click', movePrevious);
    next.addEventListener('click', moveNext);
    rail.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(requestUpdate);
    }

    cleanup.set(shell, function () {
      disposed = true;
      if (frame !== null) window.cancelAnimationFrame(frame);
      previous.removeEventListener('click', movePrevious);
      next.removeEventListener('click', moveNext);
      rail.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
      delete shell.dataset.mdvRailInitialised;
      cleanup.delete(shell);
    });

    requestUpdate();
  }

  function initialise(root) {
    (root && root.querySelectorAll ? root : document)
      .querySelectorAll('[data-mdv-collection-rail]').forEach(initialiseRail);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialise(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-mdv-collection-rail]').forEach(function (shell) {
      var dispose = cleanup.get(shell);
      if (dispose) dispose();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
